"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _uiAtoms = require("egov-ui-framework/ui-atoms");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

require("./index.css");

var _logo = require("../../../../kmcAssets/img/logo.png");

var _logo2 = _interopRequireDefault(_logo);

var _common = require("config/common");

var _common2 = _interopRequireDefault(_common);

var _actions = require("egov-ui-kit/redux/common/actions");

var _api = require("egov-ui-kit/utils/api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectedLabelStyle = { color: "#ffffff" };
var selectedStyle = { backgroundColor: "#fe7a51", border: "1px solid #fe7a51" };
var defaultStyle = {
  border: "1px solid #484848",
  borderRadius: "1px",
  marginRight: "4.65%",
  height: "44px",
  lineHeight: "44px",
  width: "28.48%",
  padding: "0 16px"
};
var defaultLabelStyle = { textTransform: "none", fontWeight: "500", color: "#484848", verticalAlign: "initial", padding: 0 };

var LanguageSelectionForm = function LanguageSelectionForm(_ref) {
  var items = _ref.items,
      onLanguageSelect = _ref.onLanguageSelect,
      onPaymentSelect = _ref.onPaymentSelect,
      fetchMDMSData = _ref.fetchMDMSData,
      value = _ref.value,
      onClick = _ref.onClick,
      logoUrl = _ref.logoUrl;

  var selectedObj = items.filter(function (obj, index) {
    return index === 0;
  });
  var handleContinueClick = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var requestBody, requestData, response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {
                  tenantId: _common2.default.tenantId,
                  moduleDetails: [{
                    moduleName: "common-masters",
                    masterDetails: [{
                      name: "StateInfo"
                    }]
                  }, {
                    moduleName: "tenant",
                    masterDetails: [{ name: "tenants" }, { name: "citymodule" }]
                  }]
                }
              };

              fetchMDMSData(requestBody);
              requestData = {
                reqData: { currentTime: new Date(), applicationId: "ekmchr" }
              };
              _context.next = 5;
              return (0, _api.httpRequest)("/pwc-db-services/generateHashToken", "", [], requestData, [], {}, true);

            case 5:
              response = _context.sent;

              localStorage.setItem("generatedhash", response.generatedhash);
              if (response) {
                onLanguageSelect();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function handleContinueClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handlePaymentClick = function handlePaymentClick() {
    return onPaymentSelect();
  };
  var isCitizen = process.env.REACT_APP_NAME === "Citizen";

  return _react2.default.createElement(_components.Card, {
    className: "col-sm-offset-4 col-sm-4 user-screens-card language-selection-card",
    textChildren: _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: "rainmaker-displayInline", style: { justifyContent: "center", alignItems: "center" } },
        _react2.default.createElement(
          "div",
          { style: {} },
          _react2.default.createElement(
            "div",
            { className: "sidebar-brand" },
            _react2.default.createElement(
              "h2",
              null,
              _react2.default.createElement(
                "a",
                { href: "", className: "logo align-items-center scrollto float-start" },
                _react2.default.createElement("img", { style: { width: "100%", marginBottom: "15px", height: "55px" }, src: _logo2.default, alt: "" })
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        "form",
        null,
        _react2.default.createElement(
          "h3",
          { style: { color: "black", fontWeight: "600", marginBottom: "25px", textAlign: "center" } },
          "Welcome To Kolkata Municipal Corporation"
        ),
        _react2.default.createElement(
          "div",
          { className: "button-container" },
          _react2.default.createElement(
            _uiAtoms.Button,
            {
              id: "continue-action",
              className: "lang-continue-button",
              style: { height: "48px", width: "100%" },
              variant: "contained",
              color: "primary",
              onClick: handleContinueClick
            },
            _react2.default.createElement(_translationNode2.default, { buttonLabel: true, labelStyle: { fontWeight: 500 }, label: "Continue" })
          ),
          isCitizen && _react2.default.createElement(
            _uiAtoms.Button,
            {
              id: "continue-action",
              className: "lang-continue-button",
              style: { height: "48px", width: "100%", marginTop: "12px" },
              fullWidth: true,
              variant: "contained",
              color: "primary",
              onClick: handlePaymentClick
            },
            _react2.default.createElement(_translationNode2.default, { buttonLabel: true, labelStyle: { fontWeight: 500 }, label: "Pay All Bill" })
          )
        )
      )
    )
  });
};

exports.default = LanguageSelectionForm;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/User/components/LanguageSelectionForm/index.js
// module id = 3394
// module chunks = 1137